module.exports = __webpack_public_path__ + "media/海岸线 (电影《我要我们在一起》配乐).150ecabc.mp3";